"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeruProvince = exports.usaProvinceToStateCode = exports.MexicoProvince = exports.UsaProvince = exports.CanadaProvince = exports.Region = exports.Licence = exports.MarketNameByMarketCode = exports.Market = exports.CountryNameByCountryCode = exports.Country = exports.MarketsByRegion = exports.CountryByMarket = void 0;
const country_1 = require("./country");
const market_1 = require("./market");
const region_1 = require("./region");
exports.CountryByMarket = {
  [market_1.Market.CANADA]: country_1.Country.CANADA,
  [market_1.Market.CANADA_ONTARIO]: country_1.Country.CANADA,
  [market_1.Market.CHILE]: country_1.Country.CHILE,
  [market_1.Market.ECUADOR]: country_1.Country.ECUADOR,
  [market_1.Market.ESTONIA]: country_1.Country.ESTONIA,
  [market_1.Market.FINLAND]: country_1.Country.FINLAND,
  [market_1.Market.ICELAND]: country_1.Country.ICELAND,
  [market_1.Market.MEXICO]: country_1.Country.MEXICO,
  [market_1.Market.NORWAY]: country_1.Country.NORWAY,
  [market_1.Market.PERU]: country_1.Country.PERU,
  [market_1.Market.SWEDEN]: country_1.Country.SWEDEN,
  [market_1.Market.USA]: country_1.Country.USA,
  [market_1.Market.USA_ARIZONA]: country_1.Country.USA,
  [market_1.Market.USA_ARKANSAS]: country_1.Country.USA,
  [market_1.Market.USA_MASSACHUSETTS]: country_1.Country.USA,
  [market_1.Market.USA_MICHIGAN]: country_1.Country.USA,
  [market_1.Market.USA_MISSISSIPPI]: country_1.Country.USA,
  [market_1.Market.USA_NEVADA]: country_1.Country.USA,
  [market_1.Market.USA_NEW_YORK]: country_1.Country.USA,
  [market_1.Market.USA_WEST_VIRGINIA]: country_1.Country.USA,
  [market_1.Market.REST_OF_THE_WORLD]: country_1.Country.REST_OF_THE_WORLD
};
exports.MarketsByRegion = {
  [region_1.Region.NORTH_AMERICA]: [market_1.Market.CANADA, market_1.Market.CANADA_ONTARIO, market_1.Market.USA, market_1.Market.USA_ARIZONA, market_1.Market.USA_ARKANSAS, market_1.Market.USA_MASSACHUSETTS, market_1.Market.USA_MICHIGAN, market_1.Market.USA_MISSISSIPPI, market_1.Market.USA_NEVADA, market_1.Market.USA_NEW_YORK, market_1.Market.USA_WEST_VIRGINIA],
  [region_1.Region.LATAM]: [market_1.Market.CHILE, market_1.Market.ECUADOR, market_1.Market.MEXICO, market_1.Market.PERU],
  [region_1.Region.NORDIC]: [market_1.Market.ESTONIA, market_1.Market.FINLAND, market_1.Market.ICELAND, market_1.Market.NORWAY, market_1.Market.SWEDEN],
  [region_1.Region.REST_OF_THE_WORLD]: [market_1.Market.REST_OF_THE_WORLD]
};
var country_2 = require("./country");
Object.defineProperty(exports, "Country", {
  enumerable: true,
  get: function () {
    return country_2.Country;
  }
});
Object.defineProperty(exports, "CountryNameByCountryCode", {
  enumerable: true,
  get: function () {
    return country_2.CountryNameByCountryCode;
  }
});
var market_2 = require("./market");
Object.defineProperty(exports, "Market", {
  enumerable: true,
  get: function () {
    return market_2.Market;
  }
});
Object.defineProperty(exports, "MarketNameByMarketCode", {
  enumerable: true,
  get: function () {
    return market_2.MarketNameByMarketCode;
  }
});
var licence_1 = require("./licence");
Object.defineProperty(exports, "Licence", {
  enumerable: true,
  get: function () {
    return licence_1.Licence;
  }
});
var region_2 = require("./region");
Object.defineProperty(exports, "Region", {
  enumerable: true,
  get: function () {
    return region_2.Region;
  }
});
var province_1 = require("./province");
Object.defineProperty(exports, "CanadaProvince", {
  enumerable: true,
  get: function () {
    return province_1.CanadaProvince;
  }
});
Object.defineProperty(exports, "UsaProvince", {
  enumerable: true,
  get: function () {
    return province_1.UsaProvince;
  }
});
Object.defineProperty(exports, "MexicoProvince", {
  enumerable: true,
  get: function () {
    return province_1.MexicoProvince;
  }
});
Object.defineProperty(exports, "usaProvinceToStateCode", {
  enumerable: true,
  get: function () {
    return province_1.usaProvinceToStateCode;
  }
});
Object.defineProperty(exports, "PeruProvince", {
  enumerable: true,
  get: function () {
    return province_1.PeruProvince;
  }
});
//# sourceMappingURL=data:application/json;base64,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